import { useMutation, useRequest } from "../../utils/api"
import { GeneralProps, ShortMutationConfigType } from "../../utils/api.type"
import { CreateRobotProps, DetailedRobotResponse, ListRobotResponse, ListRobotToAssignResponse, RobotAssignFormType } from "./robot.type"

const ENDPOINT_CREATE_ROBOT = '/v1/rms/config/robot/store/'
export const useCreateRobotMutation = (options: ShortMutationConfigType) => {
  return useMutation<any, CreateRobotProps>(ENDPOINT_CREATE_ROBOT, {
    ...options
  })
}

const ENDPOINT_LIST_ROBOT = '/v1/rms/config/robot/list/'
export const useConfigListRobot = (obj = {} as GeneralProps & { search?: string }) => {
  return useRequest<ListRobotResponse>(ENDPOINT_LIST_ROBOT, {
    ...obj,
    search: obj.search
  }, {
    enabled: obj.enabled,
    cacheKey: JSON.stringify(obj),
  })
}


const ENDPOINT_LIST_ROBOT_TO_ASSIGN = '/v1/rms/config/list-robot-to-assign/'
export const useConfigListRobotToAssign = (obj = {} as GeneralProps) => {
  return useRequest<ListRobotToAssignResponse>(ENDPOINT_LIST_ROBOT_TO_ASSIGN, {
    ...obj
  }, {
    enabled: obj.enabled,
    cacheKey: JSON.stringify(obj),
  })
}


const ENDPOINT_ASSIGN_ROBOT = '/v1/rms/config/store-robot-map-assign/'
export const useAssignRobotMutation = (options: ShortMutationConfigType) => {
  return useMutation<any, RobotAssignFormType>(ENDPOINT_ASSIGN_ROBOT, {
    ...options
  })
}

const ENDPOINT_DETAIL_ROBOT = '/v1/rms/config/robot/detail/:id/'
export const useConfigDetailRobot = (obj = {} as GeneralProps & { id: string }) => {
  return useRequest<DetailedRobotResponse>(ENDPOINT_DETAIL_ROBOT.replace(':id', obj.id), {},
  {
    enabled: obj.enabled,
    cacheKey: JSON.stringify(obj),
  })
}

const ENDPOINT_UPDATE_ROBOT = '/v1/rms/config/robot/update/:id/'
export const useUpdateRobotMutation = (options: ShortMutationConfigType & { id: string }) => {
  return useMutation<any, CreateRobotProps>(ENDPOINT_UPDATE_ROBOT.replace(':id', options.id), {
    ...options
  })
}


const ENDPOINT_UNASSIGN_ROBOT = '/v1/rms/config/robot/unassign/:id/'
export const useUnassignRobotMutation = (options: ShortMutationConfigType & { id: string }) => {
  return useMutation<any, RobotAssignFormType>(ENDPOINT_UNASSIGN_ROBOT.replace(':id', options.id), {
    ...options,
    method: "DELETE"
  })
}